import { render, staticRenderFns } from "./AttendanceParticipant.vue?vue&type=template&id=181a56fa&scoped=true&"
import script from "./AttendanceParticipant.vue?vue&type=script&lang=js&"
export * from "./AttendanceParticipant.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceParticipant.vue?vue&type=style&index=0&id=181a56fa&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181a56fa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AttendanceDate: require('/home/smiley/3df/components/Attendance/AttendanceParticipant/AttendanceDate.vue').default})
